/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Card: Image on Top
 */

import { Card, Col } from 'react-bootstrap';

// Components
import ImgNextGen from '../../../../components/ImgNextGen';

// Styles
import './style.scss';

const CardImageTop = (props) => {
    const card = props.card;

    return (
        <Col className="h-100">
            <Card className="h-100">
                <ImgNextGen
                    srcWebp={card.srcWebp}
                    fallback={card.src}
                    alt={card.title}
                />
                
                <Card.Body>
                    <Card.Title as="h5" className="text-center">{card.title}</Card.Title>
                    {/* TODO não deixar sofá-cama separar-se em duas linhas */}
                    <Card.Text className="text-muted text-center">{card.text}</Card.Text>
                </Card.Body>
            </Card>
        </Col>
    );
};

export default CardImageTop;